import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ServiceaftaleDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceaftale-dto';
import { LogicService } from 'src/app/services/logic.service';
import moment from 'moment';

@Component({
    selector: 'app-garantiaftale-tag',
    templateUrl: './garantiaftale-tag.component.html',
    styleUrls: ['./garantiaftale-tag.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GarantiaftaleTagComponent implements OnInit {
  maxGarantiEndDate: Date;
  maxGarantiEndDateString: string;
  garantiTooltip: string;
  hasGaranti: boolean = false;

  private _serviceaftale: ServiceaftaleDto;
  @Input() set serviceaftale(value: ServiceaftaleDto) {
    this._serviceaftale = value;
    if (value) {
      this.maxGarantiEndDate = this.logic.calcMaxGarantiDate(this.serviceaftale.anlaeg);
      this.maxGarantiEndDateString = this.maxGarantiEndDate ? this.datePipe.transform(this.maxGarantiEndDate, 'dd.MM.yyyy') : '';
      this.garantiTooltip = this.logic.buildGarantiTooltip(this.serviceaftale.anlaeg);
      this.hasGaranti = moment(this.maxGarantiEndDate).isSameOrAfter(moment(), 'day');
    }
  }

  get serviceaftale() {
    return this._serviceaftale;
  }

  constructor(private logic: LogicService, private datePipe: DatePipe) {}

  ngOnInit(): void {}
}
